import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import {
  getNextPageNumberNotLoaded,
  getPreviousPageNumberNotLoaded,
} from 'src/redux/products/utils/pageNumbers';
import { buildListingsURLFromState } from './state/buildListingsURLFromState';

const adaptStoreToAdjacentPageURL = (
  state: ReduxApplicationState,
  getAdjacentPageNumber: (state: ReduxApplicationState) => number | null,
): string | null => {
  const pageNumber = getAdjacentPageNumber(state);

  if (pageNumber === null) {
    return null;
  }

  return buildListingsURLFromState(state, { page: pageNumber });
};

export const adaptStoreToPreviousPageURL = (state: ReduxApplicationState): string | null => {
  return adaptStoreToAdjacentPageURL(state, (currentState) => {
    return getPreviousPageNumberNotLoaded(currentState.products.pages);
  });
};

export const adaptStoreToNextPageURL = (state: ReduxApplicationState): string | null => {
  return adaptStoreToAdjacentPageURL(state, (currentState) => {
    return getNextPageNumberNotLoaded(
      currentState.products.pages,
      currentState.products.totalPages,
    );
  });
};
